// Shown wherever a profile has no photo, and in place of a photo that fails to load.
export const PLACEHOLDER_PHOTO_URL = 'https://xprt.syd1.cdn.digitaloceanspaces.com/pub/xprt-photo-placeholder.png';
